import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  jobsData: [],
  allJobsData: [],
};

const JobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setJobsData: (state, action) => {
      state.jobsData = action.payload;
    },
    setAllJobsData: (state, action) => {
      state.allJobsData = action.payload;
    },
  },
});

export const addJob = (jobdata) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/job";
    const response = await axiosInstance.post(URL, jobdata);
    const { status, message } = response?.data || {};

    if (status === "success") {
      dispatch(setJobsData(response?.data?.data));
    }
  } catch (error) {
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(
      setErrors({
        status: error?.response?.status,
        message: errorMsg,
      })
    );
  }
  dispatch(setLoading(false));
};

export const allJobs = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    let URL = "/job";
    const response = await axiosInstance.get(URL);
    const { status, message, data } = response?.data || {};
    if (status === "success") {
      dispatch(setAllJobsData(data));
    }
  } catch (error) {
    console.log(error, "err");
    const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(
      setErrors({
        status: error?.response?.status,
        message: errorMsg,
      })
    );
  }
};

export const { setErrors, setLoading, setJobsData, setAllJobsData } =JobsSlice.actions;
export default JobsSlice.reducer;
